import { render, staticRenderFns } from "./TooltipIconClick.vue?vue&type=template&id=108c438a&scoped=true&"
import script from "./TooltipIconClick.vue?vue&type=script&lang=ts&"
export * from "./TooltipIconClick.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipIconClick.vue?vue&type=style&index=0&id=108c438a&prod&lang=scss&"
import style1 from "./TooltipIconClick.vue?vue&type=style&index=1&id=108c438a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c438a",
  null
  
)

export default component.exports